import React from "react";
import { Button, Comment } from "zina-dogi-react";
import { utils } from "~/utils";
import "./item_comments.scss";

const ItemComments = ({ onNewComment, comments, currentuser, ...props }) => {
    let ref = null;
    const newComment = event => {
        onNewComment(ref.value);
        ref.value = "";
    };
    return (
        <div {...props}>
            <ul className="comment-section">
                <li className="write-new">
                    <div className="form-group">
                        <textarea
                            ref={c => {
                                ref = c;
                            }}
                            className="form-control"
                            placeholder="Write your comment here"
                            name="comment"
                        />
                    </div>
                    <div className="row controls">
                        <Button icon="paper-plane" color="primary" onClick={newComment}>
                            Send
                        </Button>
                    </div>
                </li>
                {comments &&
                    comments.map((comment, i) => {
                        comment.date = utils.renderDate(comment.date);
                        comment.type = currentuser === comment.username ? "author" : "user";
                        return <Comment {...comment} key={`comment_${i}`} />;
                    })}
            </ul>
        </div>
    );
};
ItemComments.header = (
    <nav className="navbar">
        <span className="navbar-brand h4">Comments</span>
    </nav>
);

export default ItemComments;
